import { size as _size } from 'lodash-es';
import { dbEmployees } from 'server/database/collections';

export const fetchEmployees = async () => {
	const employeesData = await dbEmployees.getEmployees();
	return !_size(employeesData) ? [] : employeesData;
};
